<template>
  <div class="table-responsive">
    <!-------------------- Tabla de Resultados -------------------->
    <table class="table table-lightborder table-hover">
      <thead>
        <tr>
          <th class="text-left">#</th>
          <th class="text-left">Nombre de Cupón</th>
          <th class="text-left">Fecha inicio</th>
          <th class="text-left">Fecha Fin</th>
          <th class="text-left">Cant. cupones</th>
          <th class="text-left">Cant. max. cupones</th>
          <th class="text-center">Cant. cupones por cada</th>
          <th class="text-center">Cant. de Q minima de fact.</th>
          <th class="text-center">Estatus</th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="current in dataTabla.results"
          v-bind:key="current.id"
          @click="
            irAEsconderModal('pos-cuponera-editar', {
              id: current.id,
            })
          "
        >
          <td>{{ current.id }}</td>
          <td>{{ current.nombre }}</td>
          <td>{{ current.fecha_inicio }}</td>
          <td>{{ current.fecha_fin }}</td>
          <td class="text-center">{{ current.cant_cupones }}</td>
          <td class="text-center">{{ current.cant_maxima_cupones }}</td>
          <td class="text-center">Q{{ current.por_cada }}</td>
          <td class="text-center">Q{{ current.minimo_de_factura }}</td>
          <td class="text-center">
            <span class="badge badge-success" v-if="current.estatus == true"
              >Activo</span
            ><span class="badge badge-danger" v-if="current.estatus == false"
              >Inactivo</span
            >
          </td>
        </tr>
        
      </tbody>
    </table>
    <!-------------------- END - Basic Table -------------------->
    <PaginationComponent :currentPage="currentPage" :data="dataTabla" @pagechanged="onPageChange" />
  </div>
</template>

<script>
import UsuarioEnTablaComponent from "@/components/commons/UsuarioEnTablaComponent";
import Notifications from "@/notifications/notifications";
import PaginationComponent from "@/components/utils/PaginationComponent";

export default {
  components: {
    UsuarioEnTablaComponent,
    PaginationComponent,
  },
  data() {
    return {
      mostrarRefresh: false,
      currentPage: 1,
      searchtext: "",
      filtro_estado: "",
       data: [],
    };
  },
  props: ["dataTabla","refreshData"],
  computed: {},
  mounted() {
    
  },
  methods: {
    onPageChange(page) {      
      this.$emit("setActualPage",page)
      this.currentPage = page
      this.refreshData(this.currentPage);
    },

  

    irAEsconderModal(name, params) {
      if ($(".modal").hasClass("show")) {
        $(".modal").find(".close").click();
      }
      if (event.ctrlKey) {
        let routeUrl = this.$router.resolve({
          name: name,
          params: params,
        });
        window.open(routeUrl.href, "_blank");
      } else {
        this.$router.push({
          name: name,
          params: params,
        });
      }
    },
  },
};
</script>
